import createSingle from "./create-single.js";
import promoteVersion from "./promote-version.js";
import restoreRevision from "./restore-revision.js";

export default {
	createSingle,
	promoteVersion,
	restoreRevision,
};
